import { imageSource } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";

export const categoriesData = [
  {
    title: "Concept SKE - The Future of Urban Mobility",
    description:
      "Experience the future of city commuting with this sleek, eco-friendly electric motorcycle.",
    image: imageSource.bike,
    path: "https://www.matter.in/",
    isOuterRefrence: true,
    buttonText: "Check Bikes",
  },
  {
    title: "Cars for Every Journey",
    description:
      "From city commutes to long drives, discover cars that bring comfort and performance.",
    image: imageSource.white_fortuner_black_roof,
    path: PATH_DASHBOARD.home,
    isOuterRefrence: false,
    buttonText: "Check Cars",
  },
  {
    title: "Vehicle for Rent",
    description:
      "Choose your favourite scooty and bikes from a wide range of categoryies available on our store.",
    image: imageSource.self_driven,
    path: "https://nidirentals.com/",
    isOuterRefrence: true,
    buttonText: "View Vehicles",
  },
];

export const brands = ["Rolls-Royce", "Bentley", "Maybach", "Lagonda"];
export const models = ["Phantom", "Continental GT", "EQS SUV (fully electric)"];
export const sellingCarsData = [
  { name: "Audi", img: imageSource.jeep },
  { name: "Volkswagen", img: imageSource.jeep },
  { name: "Mercedes", img: imageSource.jeep },
  { name: "Ferrari", img: imageSource.jeep },
  { name: "Lamborghini", img: imageSource.jeep },
];

export const budgetOptions = Array.from({ length: 140 }, (_, i) => {
  const step = 200000;
  const min = i * step;
  const max = min + step;

  return {
    label: `${min.toLocaleString("en-IN")} - ${max.toLocaleString("en-IN")}`,
    value: `${min}-${max}`,
  };
});

// export const budgetOptions = [
//   { label: "Toyota", value: "toyota" },
//   { label: "Honda", value: "honda" },
//   { label: "SUV", value: "suv" },
//   { label: "Sedan", value: "sedan" },
// ];

export const kmDrivenOptions = [
  { label: "0 - 5,000 km", value: "0-5000" },
  { label: "5,000 - 10,000 km", value: "5000-10000" },
  { label: "10,000 - 20,000 km", value: "10000-20000" },
];
